import axios from "axios";
import {getToken, removeToken} from '../utils/auth'

const instance = axios.create({

  // baseURL: 'http://185.217.131.211/api/api/',
  baseURL: 'https://drinkme.uz/api/api/',
  timeout: 50000,
  headers: {'Content-Type': 'application/json',"Accept": "application/json"}
});

instance.interceptors.request.use(config => {
  if(getToken()) {
    config.headers['Authorization'] = `Bearer ${getToken()}`
  }

  return config
})

instance.interceptors.response.use(
    response => {
      if (response.message === 'Unauthenticated.') {
        removeToken();
        window.location = '/login'
      }
      return response
    },
    error => {
      if (error.response.message === 'Unauthenticated.') {
        window.location = '/login'
      } else if (error.response.status === 401 && getToken()) {
          removeToken();
          window.location = '/login'
      }
      else return Promise.reject(error)
    })

export default instance;
